import { GET_CMS_CONTENT } from "./actions";

const initialState = {
  cms: null,
  loading: true,
};

const rentalRentReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_CMS_CONTENT:
      return {
        ...state,
        cms: payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default rentalRentReducer;
